import Vue from 'vue';

const success = (context, response) => {
  context.closeModal('#rental-vrbo-modal');
  $('.cancel').removeClass('disabled');
  $('.confirm').removeClass('disabled');
  toastr.success(context.$t('rentals.detail.update_success'));
  context.smallLoading = false;
  context.fetch_rental(context.rental.id);
};

const failed = (context, error) => {
  context.showToasterError(error);
  context.smallLoading = false;
  if (error && error.response && error.response.data && error.response.data.haveAttachedData) {
    context.showConfirmationModal();
  }
};

export default (context, data, rentalId) => Vue.$http.post(`vrbo/update-rental-config/${rentalId}`, data)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response);
      }
    }).catch((error) => {
      failed(context, error);
    });



// WEBPACK FOOTER //
// ./src/app/services/vrbo/vrboUpdateRentalConfig.js